import { ATTRIBUTION_FIELDS } from '../interfaces/attribution.interface';
import { ReservationDetailsUiModel } from '../ui-models/reservation.ui-model';
import { ReservationDetailsModel } from '../models/reservation-details.model';

function mapToUI(reservationData: ReservationDetailsModel): ReservationDetailsUiModel {
  return {
    id: reservationData.id,
    userId: reservationData.userId,
    checkInDate: reservationData.checkInDate,
    checkOutDate: reservationData.checkOutDate,
    status: reservationData.status,
    primaryGuestName: reservationData.primaryGuestName,
    unitTypeId: reservationData.unitTypeId,
    paymentMethod: reservationData.defaultPaymentMethod,
    roomId: reservationData.roomId,
    propertyName: reservationData.propertyName,
    propertyId: reservationData.propertyId,
    unitName: reservationData.unitName,
    area: reservationData.area,
    areaId: reservationData.areaId,
    guestIds: reservationData.guestIds,
    paymentIds: reservationData.paymentIds,
    bookingMode: reservationData.bookingMode,
    bookingRequestId: reservationData.bookingRequestId,
    checkinToken: reservationData.checkinToken,
    passKey: reservationData.passKey || '',
    checkinExpiresAt: reservationData.checkinExpiresAt,
    reservationUrl: reservationData.reservationUrl,
    paymentList: reservationData.paymentList,
    channel: reservationData.channel,
    source: reservationData.source,
    typeOfStay: reservationData.typeOfStay,
    // Same field-list copy as the other two mappers. Three separate mappers
    // feed three separate view shapes here, and each is its own chance to drop
    // a field silently.
    ...ATTRIBUTION_FIELDS.reduce((acc: Record<string, unknown>, field) => {
      const value = (reservationData as unknown as Record<string, unknown>)[field];
      if (value !== undefined && value !== null && value !== '') acc[field] = value;
      return acc;
    }, {}),
    unitTypeGroupId: reservationData.unitTypeGroupId,
    channelCommission: reservationData.channelCommission,
    landlordId: reservationData.landlordId,
    landlordUsername: reservationData.landlordUsername,
    landlordEmail: reservationData.landlordEmail,
    landlordPhone: reservationData.landlordPhone,
    landlordShare: reservationData.landlordShare,
    salesPerson: reservationData.salesPerson,
    brokerId: reservationData.brokerId,
    brokerName: reservationData.brokerName,
    companyId: reservationData.companyId,
    propertyManagersList: reservationData.propertyManagersList,
    isValidated: reservationData.isValidated,
    usdRate: reservationData.usdRate,
    rateCard: reservationData?.rateCard,
    refund: reservationData.refund,
    compensation: reservationData.compensation,
    insuranceCollected: reservationData.insuranceCollected,
    actualCheckInAt: reservationData.actualCheckInAt,
    actualCheckOutAt: reservationData.actualCheckOutAt,
    roomName: reservationData.roomName,
    relatedReservationId: reservationData.relatedReservationId,
    isComplimentary: reservationData.isComplimentary,
    messages:
      reservationData.messages && reservationData.messages.length > 0
        ? reservationData.messages.map((message) => ({
            id: message.id,
            email: message.email,
            message: message.message,
            createdAt: new Date(message.createdAt),
            name: message.name
          }))
        : [],
    createdAt: reservationData.createdAt,
    createdByUsername: reservationData.createdByUsername,
    modifiedByUsername: reservationData.modifiedByUsername,
    updatedAt: reservationData.updatedAt
  };
}

export default {
  mapToUI
};
